// Banner script and notice links are configured per company in company_privacy_config (via /v1/company/privacy_config)
export const PRIVACY_FOOTER_COPYRIGHT =
    'Copyright 2008 The Siam Cement Public Company Limited. All Rights Reserved.';
